module.exports = __webpack_public_path__ + "static/media/create.12e1ed2b.svg";